import React from 'react';
import type { OptionType } from '../util/types';
import { QUERIES_IDS } from '../util/vars';
import { repository } from '@whizz/api-client';
import { useQuery } from 'react-query';
import { useLocalStorage } from 'react-use';
import Selector from '../components/selector/Selector';

type Options = {
  disabled?: boolean;
  label?: string;
};

export const useImpactReportTemplateSelector = (options?: Options): [JSX.Element, string | null] => {
  const [ selected, setSelected ] = useLocalStorage<string | null>('last_impact_report_template', null);

  const templatesQuery = useQuery<{ arn: string; name: string; description: string }[]>(
    [ QUERIES_IDS.ADMIN.GET_IMPACT_REPORT_TEMPLATES ],
    () => repository.SchoolImpactReportRepository.getTemplates(),
  );

  const templateOptions = (templatesQuery.data ?? []).map((t) => ({ label: t.name, value: t.arn }));
  const selectedOption = templateOptions.find((o) => o.value === selected) ?? null;

  const component = (
    <Selector
      id={'impact_report_template'}
      label={options?.label ?? 'Template'}
      options={templateOptions}
      placeholder={'Select template'}
      onChange={(option: OptionType<string> | null) => setSelected(option?.value ?? null)}
      value={selectedOption}
      isClearable={false}
      isLoading={templatesQuery.isFetching}
      isDisabled={options?.disabled || templatesQuery.isFetching}
    />
  );

  return [ component, selected ?? null ];
};
